import productRoutes from "@/modules/products/routes.js";
import auditlogRoutes from "@/modules/auditlog/routes.js";

const routes = [
  {
    path: "/settings",
    component: () => import(/* webpackChunkName: "SettingsIndex" */ "./views/SettingsIndex"),
    children: [
      {
        path: "client_card_settings",
        name: "client_card_settings",
        component: () => import(/* webpackChunkName: "ClientCardSettings" */ "./views/clientFields/ClientCardSettings")
      },
      {
        path: "sms_settings",
        name: "sms_settings",
        component: () => import(/* webpackChunkName: "SmsSettings" */ "./views/smsSettings/SmsSettings")
      },
      {
        path: "pdf_customization",
        name: "pdf_customization",
        component: () => import(/* webpackChunkName: "PdfCustomizationSettings" */ "./views/pdfCustomization/PdfCustomizationSettings")
      },
      {
        path: "pdf-template-preview",
        name: "pdf-template-preview",
        component: () => import(/* webpackChunkName: "TemplatePreviewModal" */ "./views/pdfCustomization/TemplatePreviewModal")
      },
      {
        path: "automation",
        name: "automation",
        component: () => import(/* webpackChunkName: "AutomationSettings" */ "./views/automation/AutomationSettings")
      },
      {
        path: "calendar_settings",
        name: "calendar_settings",
        component: () => import(/* webpackChunkName: "CalendarSettings" */ "./views/calendar/CalendarSettings"),
        props: route => ({
          staffId: route.query.staff_id,
          tab: route.query.tab,
        }),
      },
      {
        path: "taxes",
        name: "taxes",
        component: () => import(/* webpackChunkName: "TaxesSettings" */ "./views/taxes/TaxesSettings")
      },
      {
        path: "change-password",
        name: "change-password",
        component: () => import(/* webpackChunkName: "ChangePassword" */ "./views/changePassword/ChangePassword")
      },
      ...productRoutes,
      ...auditlogRoutes,
      {
        path: "*",
        redirect: { name: "client_card_settings" }
      }
    ]
  },
  {
    path: "/tracking_settings",
    name: "tracking_settings",
    component: () => import(/* webpackChunkName: "TrackingSettings" */ "./views/trackingSettings/TrackingSettings")
  },
  {
    path: "/inbox_settings",
    name: "inbox_settings",
    component: () => import(/* webpackChunkName: "InboxSettings" */ "./views/InboxSettings/InboxSettings")
  },
];
export default routes;
